import api from '@v2/lib/api';

/** Baixa um PDF autenticado da API (sessão Sanctum) usando o nome do Content-Disposition. */
export async function downloadPdf(path: string, fallbackName: string): Promise<void> {
    const response = await api.get(path, { responseType: 'blob' });
    const disposition = String(response.headers['content-disposition'] ?? '');
    const match = /filename="?([^";]+)"?/i.exec(disposition);
    const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = match?.[1] ?? fallbackName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
